import { z } from "zod/v4";

/**
 * Push `data` as the backend sends it. An app older than a `type` fails to
 * parse it, and tapping that notification then does nothing.
 */
export const NotificationDataSchema = z.object({
  type: z.enum(["alarm_activation", "camera_config_change"]),
  tenantId: z.string().optional(),
  siteId: z.string().optional(),
  cameraKey: z.string().optional(),
});

export type NotificationData = z.infer<typeof NotificationDataSchema>;

export type PermissionStatus = "granted" | "denied" | "undetermined";

export type PushNotificationStatus = {
  permission: PermissionStatus;
  registered: boolean;
  token?: string;
  ttl?: number;
};
